import React from "react";
import {Spin} from "antd";
import cn from "classnames";

export const Preloader = ({size, colorful, addClass}) => {
  return (
    <div className={cn(addClass || "preloader", {__colorful: colorful})}>
      <Spin size={size || "large"} />
    </div>
  );
};
